var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumbers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 162,
    viewBox: "0 0 1200 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_29_2644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.288 15.072C47.393 8.28923 48.4455 4.89783 51.0909 2.94892C53.7364 1 57.2874 1 64.3893 1H1175.06C1186.8 1 1192.67 1 1195.68 4.82669C1198.68 8.65338 1197.28 14.3543 1194.49 25.7561L1165.11 145.756C1163.32 153.075 1162.42 156.734 1159.71 158.867C1156.99 161 1153.22 161 1145.69 161H27.148C14.7295 161 8.52031 161 5.52286 156.931C2.52541 152.863 4.36581 146.932 8.04662 135.072L45.288 15.072Z",
    fill: "url(#paint0_linear_29_2644)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0003 69.4544C29.0003 69.4544 39.7972 30.242 47.9155 5.95443C48.9028 3.00041 51.375 1.4544 54.5003 1.4544C85.9152 1.4544 131.618 1.66667 131.618 1.66667",
    stroke: "url(#paint1_linear_29_2644)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1177 93.5C1177 93.5 1190.8 35.571 1195 11C1195.53 7.9299 1193.5 1.99998 1189 2.00001C1157.59 2.00023 1111 1.64101 1111 1.64101",
    stroke: "url(#paint2_linear_29_2644)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M31.5 160L125.5 160.025L132.5 160L403 160",
    stroke: "url(#paint3_linear_29_2644)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_29_2644",
    x: -95.9751,
    y: -99,
    width: 1393.33,
    height: 360,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_29_2644"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_29_2644",
    result: "effect2_dropShadow_29_2644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_29_2644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_2644",
    x1: 0,
    y1: 81,
    x2: 1200.55,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239047,
    stopColor: "#1A3639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E7E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_2644",
    x1: 121.008,
    y1: 2.97488,
    x2: 50.7007,
    y2: 73.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#62E4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875024,
    stopColor: "#0F6E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_2644",
    x1: 1121.61,
    y1: 2.94927,
    x2: 1191.92,
    y2: 73.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#62E4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875024,
    stopColor: "#0F6E4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_2644",
    x1: 198.96,
    y1: 161.213,
    x2: 128.904,
    y2: 231.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419058,
    stopColor: "#62E4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729078,
    stopColor: "#0F6E4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/Numbers.abe781d68278419ed5c3eed336b4582b.svg";
export { ForwardRef as ReactComponent };